/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_5_QInputs */

const en_mk_faq_5_q = /** @type {(inputs: Mk_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does Bystep decide a task is done?`)
};

const id_mk_faq_5_q = /** @type {(inputs: Mk_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana Bystep menentukan tugas selesai?`)
};

/**
* | output |
* | --- |
* | "How does Bystep decide a task is done?" |
*
* @param {Mk_Faq_5_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_5_q = /** @type {((inputs?: Mk_Faq_5_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_5_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_5_q(inputs)
	return en_mk_faq_5_q(inputs)
});